import { useState } from "react";
import getNamesbyPincode from "india-pincode-search";

const usePincodeSearch = () => {
    const [locationDetails, setLocationDetails] = useState(null);

    const getLocationDetails = async (pincode) => {
        if (pincode && pincode.length === 6) {
            try {
                // console.log("Fetching location details for pincode:", pincode);
                const pincodes = await getNamesbyPincode.search(pincode);
                // console.log("Location details:", pincodes);
                if (pincodes?.length > 0) {
                    const locationData = {
                        pincode: pincode,
                        city: pincodes[0]?.district,
                        state: pincodes[0]?.state,
                    };
                    setLocationDetails(locationData);
                    return locationData; // Return the data for immediate use
                }
            } catch (error) {
                console.log("Error fetching location details:", error);
            }
        }
        setLocationDetails(null);
        return null; // Return null if pincode is invalid or no data found
    };

    return { locationDetails, getLocationDetails };
};

export default usePincodeSearch;
